import { render, staticRenderFns } from "./AgencyProjectSummaryView.vue?vue&type=template&id=57b46658&scoped=true&"
import script from "./AgencyProjectSummaryView.vue?vue&type=script&lang=js&"
export * from "./AgencyProjectSummaryView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57b46658",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/app/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
installComponents(component, {VBtn,VCardText,VCardTitle,VLayout})
